import React from 'react';
import styled from 'styled-components';
import { Step, Stepper, StepLabel } from '@material-ui/core';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const HeaderWrapper = styled.div`
  text-align: center;
`;

const CustomStepper = styled(Stepper)`
  &&& {
    width: 100%;
    background: transparent;
  }
`;

const steps = [
  {
    id: 'profile',
    text: 'My profile',
  },
  {
    id: 'company',
    text: 'Company info',
  },
  {
    id: 'productRange',
    text: 'Product range',
  },
  {
    id: 'confirmation',
    text: 'Confirmation',
  },
];
const stepsUser = [
  {
    id: 'profile',
    text: 'My profile',
  },
];
const stepsNonArup = [
  {
    id: 'profile',
    text: 'My profile',
  },
  {
    id: 'company',
    text: 'Company info',
  },
  {
    id: 'confirmation',
    text: 'Confirmation',
  },
];
const stepsUserCompany = [
  {
    id: 'profile',
    text: 'My profile',
  },
  {
    id: 'productRange',
    text: 'Product range',
  },
  {
    id: 'confirmation',
    text: 'Confirmation',
  },
];

const getActiveStepIndex = activeStep => {
  switch (activeStep) {
    case 'profile':
      return 0;
    case 'company':
      return 1;
    case 'productRange':
      return 2;
    case 'confirmation':
      return 3;
    default:
      break;
  }
};

const activeStepForRepresentative = activeStep => {
  switch (activeStep) {
    case 'profile':
      return 0;
    case 'productRange':
      return 1;
    case 'confirmation':
      return 2;
    default:
      break;
  }
};

const RegisterModalHeader = ({ activeStep, registrationData }) => (
  <HeaderWrapper>
    <Container>
      {registrationData.type === 'ARUP_REGISTRATION' ? (
        <CustomStepper activeStep={getActiveStepIndex(activeStep)}>
          {stepsUser.map(step => {
            return (
              <Step key={step.id}>
                <StepLabel>{step.text}</StepLabel>
              </Step>
            );
          })}
        </CustomStepper>
      ) : registrationData.type === 'COMPANY_USER_REGISTRATION' ? (
        <CustomStepper activeStep={activeStepForRepresentative(activeStep)}>
          {stepsUserCompany.map(step => {
            return (
              <Step key={step.id}>
                <StepLabel>{step.text}</StepLabel>
              </Step>
            );
          })}
        </CustomStepper>
      ) : registrationData.type === 'COMPANY_REGISTRATION' ? (
        <CustomStepper activeStep={getActiveStepIndex(activeStep)}>
          {steps.map(step => {
            return (
              <Step key={step.id}>
                <StepLabel>{step.text}</StepLabel>
              </Step>
            );
          })}
        </CustomStepper>
      ) : (
        <CustomStepper activeStep={getActiveStepIndex(activeStep)}>
          {stepsNonArup.map(step => {
            return (
              <Step key={step.id}>
                <StepLabel>{step.text}</StepLabel>
              </Step>
            );
          })}
        </CustomStepper>
      )}
    </Container>
    You can change these settings after registration if required
  </HeaderWrapper>
);

export default RegisterModalHeader;
